// Auto-generated normalizer for table: EstudianteCertificaciones
export function estudianteCertificacionesNormalize(row) {
  return {
    idEstudiantesCertificaciones: row.idEstudiantesCertificaciones ?? row.IdEstudiantesCertificaciones ?? row['IdEstudiantesCertificaciones'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    idCertificacion: row.idCertificacion ?? row.IdCertificacion ?? row['IdCertificacion'] ?? 0,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
    rutaCertificadoURL: row.rutaCertificadoURL ?? row.RutaCertificadoURL ?? row['RutaCertificadoURL'] ?? '',
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
